<script>
	import LoginScreen from '../components/login-screen.vue'
	import isMobile from '../mobile.js'

	// {{{ void checkBrowserFeatures( function onCheck )

	function checkBrowserFeatures( onCheck ) {
		function requireTrue( bTrue, aWarning ) {
			if ( ! bTrue ) {
				try {
					if ( 'console' in window ) {
						console.warn.apply(console, aWarning);
					}
				}
				catch ( oErr ) {
					// Catch (and ignore) console.* methods not being real
					// JS functions in IE8 and below
				}
			}

			return bTrue;
		}

		function requireIn( sNeedle, oHaystack ) {
			return requireTrue(
				sNeedle in oHaystack,
				['Required property ', sNeedle, ' not found in ', oHaystack]
			);
		}

		setTimeout(function( sArg ) {
			var oCanvas = document.createElement('canvas'),
				sStorageKey = 'localstorage-test',
				bLocalStorage;
				
			try {
				localStorage.setItem(sStorageKey, sStorageKey);
				localStorage.removeItem(sStorageKey);
				bLocalStorage = true;
			}
			catch ( oErr ) {
				if ( 'console' in window ) {
					console.warn('localStorage test failed: ', oErr.message);
				}

				bLocalStorage = false;
			}

			onCheck(

				// setTimeout/setInterval argument passing
				requireTrue(
					sArg == 'test',
					['setTimeout parameter passing not supported']
				)

				// localStorage (see above)
				&& requireTrue(
					bLocalStorage,
					['localStorage not supported']
				)

				// 'use strict' support (requiring declaration of such above)
				&& requireTrue(
					(function() { return !this; })(),
					['"use strict" not supported']
				)

				// JSON parsing and serialization
				&& requireIn('JSON', window)

				// IFRAME sandboxing
				&& requireIn('sandbox', document.createElement('iframe'))

				// Inline SVG
				&& requireTrue(
					document.createElementNS
					&& document.createElementNS(
						'http://www.w3.org/2000/svg', 'svg'
					).createSVGRect,
					['Inline SVG not supported']
				)

				// SVG as image
				&& requireTrue(
					document.implementation.hasFeature(
						'http://www.w3.org/TR/SVG11/feature#Image', '1.1'
					),
					['SVG images not supported']
				)

				// File API
				&& requireIn('File', window)
				&& requireIn('FileList', window)
				&& requireIn('FileReader', window)

				// XMLHttpRequest level 2
				&& requireIn('FormData', window)

				// DOM level 2 event listeners
				&& requireIn('addEventListener', Element.prototype)

				// Window hash change events
				&& requireIn('onhashchange', window)

				// Canvas
				&& requireIn('getContext', oCanvas)
				&& requireTrue(
					oCanvas.getContext('2d'),
					['Canvas not supported']
				)

				// ECMAScript 5 object methods
				&& requireIn('isArray', Array)
				&& requireIn('map', Array.prototype)
				&& requireIn('forEach', Array.prototype)
				&& requireIn('some', Array.prototype)
				&& requireIn('every', Array.prototype)
				&& requireIn('filter', Array.prototype)
				&& requireIn('reduce', Array.prototype)
				&& requireIn('keys', Object)
				&& requireIn('bind', Function.prototype)

				// Element classList (living standard)
				&& requireIn('classList', oCanvas)

				// Base-64 encoding and decoding (living standard)
				&& requireIn('btoa', window)
				&& requireIn('atob', window)

				// Debug console (living standard)
				&& requireIn('console', window)

				// Beacon API
				// Enforced only for mobile devices, as only the mobile
				// admin requires it at this time.
				&& requireTrue(
					! isMobile() || ('sendBeacon' in window.navigator),
					['Mobile device without beacon support']
				)

				// ES6 module support
				&& requireIn('noModule', window.HTMLScriptElement.prototype)

			);
		}, 0, 'test');
	}

	// }}}
	// {{{ void checkFieldAutofill( object oRef )

	/**
	 * Check whether Chrome is claiming to autofill a text field's value, and
	 * force the field's label into active state if so.
	 *
	 * This is necessary for working around the fact that Chrome's password
	 * manager does not indicate to the page that it has (visually) filled the
	 * field with a value. This results in the value overlapping the field label
	 * which acts as a placeholder when the field is empty.
	 */
	function checkFieldAutofill( oRef ) {
		if ( ! oRef )  return;

		let oEl = oRef.$el;
		if ( ! oEl )  return;

		let bDirt = oEl.querySelector('input:-webkit-autofill'),
			oLabel = oEl.querySelector('label');

		if ( bDirt && oLabel ) {
			oLabel.classList.add('v-label--active');
		}

		return bDirt;
	}

	// }}}

	// {{{ renderErrorAlert( function h ) : object

	function renderErrorAlert( h ) {
		return h('v-alert', {
			attrs: {
				type: 'error',
				dismissible: true
			},
			props: {
				value: this.error !== null
			},
			on: {
				input: bValue => {
					if ( ! bValue ) {
						this.error = null;
					}
				}
			}
		}, [this.error]);
	}

	// }}}
	// {{{ renderBrowserSupportFailed( function h ) : object

	function renderBrowserSupportFailed( h ) {
		return h(LoginScreen, [
			h('v-alert', {
				attrs: {
					id: 'support-alert',
					type: 'error'
				}
			}, [
				'Your web browser is lacking some of the features'
					+' required to access this software. Please check ',
				h('a', {
					attrs: {
						href: 'https://help.bloxcms.com/knowledge-base/applications/faq/article_6ef5c06c-2c01-11e5-824c-7f6d684c2871.html'
					}
				}, ['the support matrix']),
				' for a supported browser on your system.'
			])
		]);
	}

	// }}}
	// {{{ renderTOTPDialog( function h ) : object

	function renderTOTPDialog( h ) {
		return h('v-dialog', {
			props: {
				value: this.totpRequired,
				maxWidth: 300,
				persistent: true
			},
			on: {
				input: bValue => this.totpRequired = bValue
			}
		}, [
			h('v-card', [
				h('v-card-title', [
					h('span', {class: 'headline'}, [
						'Enter your 6 digit authentication code'
					])
				]),
				h('v-card-text', [
					h('v-alert', {
						attrs: {
							type: 'error',
							dismissible: false
						},
						props: {
							value: this.totpError !== null
						}
					}, [this.totpError]),
					h('v-text-field', {
						ref: 'totpField',
						props: {
							'single-line': true,
							solo: true,
							value: this.totp
						},
						on: {
							input: sCode => {
								this.totp = sCode;
							},
							keydown: oEv => {
								if ( oEv.key == 'Enter' ) {
									this.adminLogin();
								}
							}
						}
					})
				]),
				h('v-card-actions', [
					h('v-spacer'),
					h('v-btn', {
						attrs: {
							color: 'primary',
							type: 'submit'
						},
						props: {
							disabled: this.submitting
						},
						on: {
							click: oEv => {
								oEv.preventDefault();
								this.adminLogin();
							}
						}
					}, [this.submitting ? 'Logging in...' : 'Log in']),
					h('v-btn', {
						on: {
							click: oEv => {
								oEv.preventDefault();
								this.totpRequired = false;
							}
						}
					}, ['Cancel'])
				])
			])
		]);
	}

	// }}}
	// {{{ renderVerifyDialog( function h ) : object

	function renderVerifyDialog( h ) {
		return h('v-dialog', {
			props: {
				value: this.verifyRequired,
				maxWidth: 300,
				persistent: true
			},
			on: {
				input: bValue => this.verifyRequired = bValue
			}
		}, [
			h('v-card', [
				h('v-card-title', [
					h('span', {class: 'headline'}, [
						'New login detected'
					])
				]),
				h('v-card-text', [
					h('v-alert', {
						attrs: {
							type: 'error',
							dismissible: false
						},
						props: {
							value: this.verifyError !== null
						}
					}, [this.verifyError]),
					h('div', [
						'This appears to be the first time you have logged in from this device. A verification code has been sent to your account email address. Please enter the verification code to continue:'
					]),
					h('v-text-field', {
						ref: 'verifyField',
						props: {
							'single-line': true,
							solo: true,
							value: this.verifyCode
						},
						on: {
							input: sCode => {
								this.verifyCode = sCode;
							},
							keydown: oEv => {
								if ( oEv.key == 'Enter' ) {
									this.verifyClient();
								}
							}
						}
					})
				]),
				h('v-card-actions', [
					h('v-spacer'),
					h('v-btn', {
						attrs: {
							color: 'primary',
							type: 'submit'
						},
						props: {
							disabled: this.submitting
						},
						on: {
							click: oEv => {
								oEv.preventDefault();
								this.verifyClient();
							}
						}
					}, [this.submitting ? 'Verifying...' : 'Verify']),
					h('v-btn', {
						on: {
							click: oEv => {
								oEv.preventDefault();
								this.verifyRequired = false;
							}
						}
					}, ['Cancel'])
				])
			])
		]);
	}

	// }}}
	// {{{ renderLoginBanner( function h ) : object

	function renderLoginBanner( h ) {
		return h('v-alert', {
			attrs: {
				type: 'info'
			},
			props: {
				value: this.$store.getters.loginBanner
			}
		}, [ this.$store.getters.loginBanner ]);
	}

	// }}}
	// {{{ renderLoginForm( function h ) : object

	function renderLoginForm( h ) {
		let aChildren = [
			renderTOTPDialog.call(this, h),
			renderVerifyDialog.call(this, h),
			renderLoginBanner.call(this, h)
		];

		aChildren.push(
			h('v-text-field', {
				ref: 'email',
				attrs: {
					name: 'email',
					label: 'Enter your email address',
					type: 'email',
					autocorrect: 'off',
					autocapitalize: 'off',
					required: true,
					autofocus: ! this.emailSubmitted,
					disabled: !! this.emailSubmitted,
					readonly: !! this.emailSubmitted
				},
				props: {
					value: this.email
				},
				on: {
					input: sValue => {
						this.email = sValue;
					}
				}
			})
		);

		if ( ! this.emailSubmitted ) {
			// {{{ first-stage buttons
			aChildren.push(h('v-container', {attrs: {fluid: true, 'pa-0': true}}, [
				h('v-layout', {attrs: {row: true, wrap: true}}, [
					h('v-flex', {
						attrs: {
							xs12: true,
							'text-xs-right': true
						}
					}, [
						h('v-btn', {
							attrs: {
								style: 'background-color:#5F249F; color:white'
							},
							props: {
								disabled: this.emailSubmitting
							},
							on: {
								click: () => {
									this.submitEmail();
								}
							}
						}, 'Continue')
					])
				])
			]));
			// }}}
			if ( this.$store.getters.staffLoginAvailable ) {
				// {{{ staff login button
				aChildren.push(
					h('v-container', {attrs: {'text-xs-center': true, 'pa-0': true}}, [
						h('v-layout', {attrs: {row: true, wrap: true}}, [
							h('v-flex', {
								attrs: {
									'xs12': true
								}
							}, [
								h('v-btn', {
									attrs: {
										flat: true
									},
									on: {
										click: () => {
											this.staffLogin();
										}
									}
								}, 'Staff login')
							])
						])
					])
				);
				// }}}
			}
		}
		else {
			aChildren.push(
				// {{{ password field
				h('v-text-field', {
					ref: 'password',
					attrs: {
						name: 'password',
						label: 'Password',
						type: 'password',
						required: true,
						autofocus: true
					},
					props: {
						value: this.password
					},
					on: {
						input: sValue => {
							this.password = sValue;
						}
					}
				}),
				// }}}
				h('v-container', {attrs: {fluid: true, 'pa-0': true}}, [
					// {{{ second-stage login buttons
					h('v-layout', {attrs: {row: true, wrap: true}}, [
						h('v-flex', {
							attrs: {
								xs12: true,
								//sm6: true,
								'text-xs-right': true,
								//'order-xs1': true,
								//'order-sm2': true
							}
						}, [
							h('v-btn', {
								attrs: {
									flat: true
								},
								props: {
									disabled: this.submitting
								},
								on: {
									click: oEv => {
										oEv.preventDefault();
										this.password = '';
										this.emailSubmitting = false;
										this.emailSubmitted = false;
									}
								}
							}, ['Cancel']),
							h('v-btn', {
								attrs: {
									color: 'primary',
									type: 'submit'
								},
								props: {
									disabled: this.submitting
								}
							}, [this.submitting ? 'Logging in...' : 'Log in'])
						])/*,
						h('v-flex', {
							attrs: {
								xs12: true,
								sm6: true,
								'text-xs-center': true,
								'text-sm-left': true,
								'order-xs2': true,
								'order-sm1': true
							}
						}, [
							h('v-btn', {
								attrs: {
									flat: true,
									to: '/-/login/forgot'
								}
							}, 'Forgot your password?')
						])
						*/
					]),
					// }}}
					// {{{ forgot your password button
					h('v-layout', {attrs: {row: true, wrap: true}}, [
						h('v-flex', {
							attrs: {
								'xs12': true,
								'text-xs-center': true
							}
						}, [
							h('v-btn', {
								attrs: {
									flat: true,
									to: '/-/login/forgot'
								}
							}, 'Forgot your password?')
						])
					])
					// }}}
				])
			);
		}

		return h(LoginScreen, [
			renderErrorAlert.call(this, h),
			h('form', {
				on: {
					submit: oEv => {
						oEv.preventDefault();

						if ( this.emailSubmitted ) {
							this.login();
						}
						else {
							this.submitEmail();
						}
					}
				}
			}, aChildren)
		]);
	}

	// }}}

	export default {

		// {{{ data

		data: () => ({
			browserSupported: null,
			emailSubmitting: false,
			emailSubmitted: false,
			submitting: false,
			error: null,
			email: '',
			password: '',
			totp: '',
			totpError: null,
			totpRequired: false,
			verifyRequired: false,
			verifyCode: '',
			verifyError: null
		}),

		// }}}

		// {{{ created()

		created() {
			setTimeout(() => {
				if ( this.browserSupported === null ) {
					this.browserSupported = false;
				}

				if ( ! this.browserSupported ) {
					let oAlert = document.getElementById('support-alert');

					if ( oAlert.style.display == 'none' ) {
						oAlert.style.display = 'block';
					}
				}
			}, 2000);

			checkBrowserFeatures(bSupported => {
				this.browserSupported = bSupported;
			});
		},

		// }}}
		// {{{ mounted()

		mounted() {
			// Mark login fields as dirty after page load if browser password
			// autofill is detected.

			let bEmailDirt = false,
				bPasswordDirt = false,
				nIterations = 20;

			const nIntervalID = setInterval(() => {
				nIterations -= 1;

				if (
					(bEmailDirt && bPasswordDirt)
					|| nIterations < 0
				) {
					clearInterval(nIntervalID);
				}
				else {
					bEmailDirt = checkFieldAutofill(this.$refs.email);
					bPasswordDirt = checkFieldAutofill(this.$refs.password);
				}
			}, 100);
		},

		// }}}

		watch: {
			// {{{ totpRequired

			totpRequired( bValue ) {
				if ( bValue ) {
					requestAnimationFrame(() => {
						this.$refs.totpField.focus();
					});
				}
				else {
					this.totp = '';
					this.totpError = null;
				}
			},

			// }}}
			// {{{ verifyRequired

			verifyRequired( bValue ) {
				if ( bValue ) {
					requestAnimationFrame(() => {
						this.$refs.verifyField.focus();
					});
				}
				else {
					this.verifyCode = '';
					this.verifyError = null;
				}
			}

			// }}}
		},

		methods: {
			// {{{ submitEmail

			submitEmail() {
				this.emailSubmitting = true;

				this.$systemAPI('login/method', {
						email: this.email
					})
					.then(oResp => {
						switch ( oResp.method ) {
							case 'password':
								this.emailSubmitted = true;
								break;

							case 'staff':
								this.staffLogin();
								break;

							case 'saml':
								this.samlLogin(oResp.idp);
								break;
						}
					})
					.catch(oErr => {
						this.emailSubmitting = false;
						this.error = oErr.message;
						this.$refs.email.focus();
					});
			},

			// }}}
			// {{{ login

			login() {
				if ( /@townnews\.com$/.test(this.email) ) {
					this.staffLogin();
				}
				else {
					this.adminLogin();
				}
			},

			// }}}
			// {{{ adminLogin

			adminLogin() {
				this.submitting = true;
				this.error = null;
				this.totpError = null;

				this.$systemAPI('login', {
						email: this.email,
						password: this.password,
						totp: this.totp
					})
					.then(oResp => {
						if ( oResp.totp_required || oResp.totp_invalid ) {
							this.submitting = false;
							this.totpRequired = true;
							this.verifyRequired = false;

							if ( oResp.totp_invalid ) {
								this.totpError = 'Invalid authentication code';
							}
						}
						else if ( oResp.client_unknown ) {
							this.submitting = false;
							this.totpRequired = false;
							this.verifyRequired = true;
						}
						else {
							this.afterLogin(oResp);
						}
					})
					.catch(oErr => {
						this.submitting = false;
						this.totpRequired = false;
						this.error = oErr.message;
						this.$refs.email.focus();
					});
			},

			// }}}
			// {{{ staffLogin

			staffLogin() {
				window.location = '/-/login/staff?return='
					+ encodeURIComponent(
						this.$route.query.then
						|| (
							window.location.pathname
							+ window.location.hash
							+ window.location.search
						)
					);
			},

			// }}}
			// {{{ samlLogin

			samlLogin( sIdP ) {
				window.location = '/-/login/saml?idp='
					+ encodeURIComponent(sIdP)
					+'&return='
					+ encodeURIComponent(
						this.$route.query.then
						|| (
							window.location.pathname
							+ window.location.hash
							+ window.location.search
						)
					);
			},

			// }}}
			// {{{ verifyClient

			verifyClient() {
				let sCode = this.verifyCode.trim();

				if ( ! sCode ) {
					this.verifyError = 'Please enter the verification code'
						+' from your email';
					return;
				}

				this.submitting = true;
				this.verifyError = null;

				this.$systemAPI('login/verify', {
						code: sCode
					})
					.then(oResp => {
						this.afterLogin(oResp);
					})
					.catch(oErr => {
						this.submitting = false;
						this.verifyRequired = false;
						this.error = oErr.message;
					});
			},

			// }}}
			// {{{ afterLogin

			afterLogin( oResp ) {
				let sURL;

				if ( this.$route.query.then ) {
					// Existing mobile route

					sURL = this.$route.query.then;
				}
				else if ( window.location.hash ) {
					// Existing desktop route

					sURL = '/desktop/'+ window.location.hash;
				}
				else if ( oResp.site ) {
					// No existing route but default site

					if ( isMobile() ) {
						sURL = '/'+ oResp.site +'/';
					}
					else {
						sURL = '/desktop/#/'+ oResp.site;
					}
				}
				else {
					// Shouldn't get here, but punt to old UI if so

					sURL = '/desktop/';
				}

				let sExisting = window.location.pathname + window.location.hash;

				if ( sExisting == sURL ) {
					window.location.reload();
				}
				else {
					window.location = sURL;
				}
			}

			// }}}
		},

		render( h ) {
			if ( this.browserSupported === null ) {
				// Show dead air until the browser support check completes
				return h(LoginScreen, h('div', 'Loading...'));
			}
			else if ( this.browserSupported === false ) {
				// Show error in place of login if the browser support check failed
				return renderBrowserSupportFailed.call(this, h);
			}
			else {
				// Otherwise, render the login form
				return renderLoginForm.call(this, h);
			}
		}
	};
</script>
